/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocials, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocialsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocialsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocials';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocials(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocialsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocialsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocials(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherSocialsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsSocials.js.map